import React from 'react'
import { Link } from 'gatsby'
import v4 from 'uuid/v4'

const listStyle = {
	badge: {
		list: "list-badge list-inline",
		item: "list-badge-item list-inline-item",
		link: "list-badge-link badge badge-secondary p-3 mb-md-3 mr-3"
	},
	menu: {
		list: "list-menu list-unstyled",
		item: "list-menu-item",
		link: "list-menu-link"
	},
	list:{
		list: "list-list list-unstyled",
		item: "list-list-item mb-3",
		link: "list-list-link"
	}
}

const Links = ({attrs = {}}) => {
	// Gestion des props manquantes avec valeurs par défaut
	const safeAttrs = {
		title: attrs?.title || 'Liste de liens',
		displayMode: attrs?.displayMode || 'list',
		items: Array.isArray(attrs?.items) ? attrs.items : []
	}

	// Vérification que le mode d'affichage est valide
	const validDisplayMode = listStyle[safeAttrs.displayMode] ? safeAttrs.displayMode : 'list'
	const currentStyle = listStyle[validDisplayMode]

	return (
		<div className="mb-5">
			<h2>{safeAttrs.title}</h2>
			<ul className={currentStyle.list}>
				{safeAttrs.items && safeAttrs.items.map(({title, full_url, slug, blank}) => {
					// Gestion des propriétés manquantes des items
					const safeTitle = title || 'Lien sans titre'
					const safeBlank = blank || false
					const safeRel = safeBlank ? "noopener noreferrer" : ""
					const safeTarget = safeBlank ? "_blank" : "_self"
					
					return (
						<li key={v4()} className={currentStyle.item}>
							{slug ? (
								<Link 
									className={currentStyle.link} 
									target={safeTarget} 
									rel={safeRel} 
									to={slug}
								>
									{safeTitle}
								</Link>
							) : (
								<a 
									className={currentStyle.link} 
									target={safeTarget} 
									rel={safeRel} 
									href={full_url || '#'}
								>
									{safeTitle}
								</a>
							)}
						</li>
					)
				})}
			</ul>
		</div>
	)
}

export default Links
